var _style, _path, _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoRigilog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 677.3 233.9",
    width: 300,
    height: 104,
    style: {
      enableBackground: "new 0 0 677.3 233.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E63020;}\r\n\t.st1{clip-path:url(#SVGID_2_);}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:11.622;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{display:none;}\r\n\t.st5{display:inline;}\r\n\t.st6{display:none;fill:#014B59;}\r\n\t.st7{fill:none;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rigilog_AG_Logo_1_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.2,231l-84.1-48.6c-6.2-3.6-10-10.2-10-17.3V68.4c0-7.2,3.8-13.8,10-17.3l84-48.3c6.2-3.6,13.8-3.5,20,0 l35.2,20.3l48.6,28c6.2,3.6,10,10.2,10,17.3v96.9c0,7.1-3.8,13.7-10,17.3L114.2,231C108,234.6,100.4,234.6,94.2,231z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M94.2,231.2L10,182.6C3.8,179,0,172.4,0,165.2V68.4C0,61.2,3.8,54.6,10,51L94.1,2.7 c6.2-3.6,13.8-3.6,20,0L149.3,23L198,51.1c6.2,3.6,10,10.2,10,17.3v97c0,7.2-3.8,13.8-10,17.3l-83.8,48.4 C108,234.8,100.4,234.8,94.2,231.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 2.9,
    y1: 175.3,
    x2: 64.4,
    y2: 139.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.8,152.3c6.7-3.9,9-12.4,5.1-19.1c-3.9-6.7-12.4-9-19.1-5.1c-6.7,3.9-9,12.4-5.1,19.1 C55.5,153.9,64.1,156.2,70.8,152.3z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 13.8,
    y1: 212,
    x2: 159.5,
    y2: 128.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M165.9,140.7c6.7-3.9,9-12.4,5.1-19.1c-3.9-6.7-12.4-9-19.1-5.1c-6.7,3.9-9,12.4-5.1,19.1 C150.6,142.2,159.2,144.5,165.9,140.7z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 65.8,
    y1: 223.5,
    x2: 137.6,
    y2: 182
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144,194.5c6.7-3.9,9-12.4,5.1-19.1s-12.4-9-19.1-5.1c-6.7,3.9-9,12.4-5.1,19.1 C128.8,196,137.3,198.3,144,194.5z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Medium_4_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.3,128.3h-18.7v38.5h-15v-100h42.1c19,0,32.1,12.3,32.1,30.7c0,18-12.1,27.6-24.9,29.2l25.6,40h-17.4 L276.3,128.3z M282.8,80h-25.2v35.1h25.2c10.8,0,18.6-7,18.6-17.5C301.4,87,293.6,80,282.8,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.9,73.7c0-4.8,4-8.7,8.7-8.7c4.8,0,8.7,3.9,8.7,8.7s-3.9,8.5-8.7,8.5C336.9,82.2,332.9,78.5,332.9,73.7z  M335,94.4h13.5v72.4H335V94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M375.8,175.5c6,6.9,13.3,9.6,23.2,9.6c11.2,0,22.5-5.4,22.5-20.7V155c-5.5,7.2-14.1,12.4-23.8,12.4 c-18.7,0-32.2-13.8-32.2-37.5c0-23.2,13.5-37.3,32.2-37.3c9.4,0,18,4.5,23.8,12.3V94.4H435V164c0,24.9-18.1,32.2-36,32.2 c-12.1,0-21-2.5-29.7-10.8L375.8,175.5z M421.5,115.2c-3.8-5.8-12-10.6-20.1-10.6c-13.5,0-21.9,10.5-21.9,25.3 c0,15,8.4,25.5,21.9,25.5c8.1,0,16.3-5,20.1-10.8V115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.4,73.7c0-4.8,4-8.7,8.7-8.7c4.8,0,8.7,3.9,8.7,8.7s-3.9,8.5-8.7,8.5C458.4,82.2,454.4,78.5,454.4,73.7z  M456.5,94.4H470v72.4h-13.5V94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M491.4,66.8h13.5v100h-13.5V66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.9,130.5c0-20.8,14.1-37.9,36.6-37.9c22.6,0,36.6,17.1,36.6,37.9c0,21-13.9,38.1-36.6,38.1 C536,168.6,521.9,151.5,521.9,130.5z M581,130.5c0-13.6-7.9-25.9-22.5-25.9c-14.4,0-22.5,12.3-22.5,25.9 c0,13.8,8.1,26.1,22.5,26.1C573,156.6,581,144.3,581,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M618,175.5c6,6.9,13.3,9.6,23.2,9.6c11.2,0,22.5-5.4,22.5-20.7V155c-5.5,7.2-14.1,12.4-23.8,12.4 c-18.7,0-32.2-13.8-32.2-37.5c0-23.2,13.5-37.3,32.2-37.3c9.4,0,18,4.5,23.8,12.3V94.4h13.5V164c0,24.9-18.1,32.2-36,32.2 c-12.1,0-21-2.5-29.7-10.8L618,175.5z M663.8,115.2c-3.8-5.8-12-10.6-20.1-10.6c-13.5,0-21.9,10.5-21.9,25.3 c0,15,8.4,25.5,21.9,25.5c8.1,0,16.3-5,20.1-10.8V115.2z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Invers",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rigilog_AG_Logo",
    className: "st5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -33.7,
    y: -34.5,
    className: "st6",
    width: 744.9,
    height: 302.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rigilog_Logo_Invers"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "43.4,201.7 43.3,201.8 67.5,215.8 67.7,215.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M6.6,179.9l49.1-28.3c4.3,3.1,10.2,3.6,15.1,0.7c6.7-3.9,9-12.4,5.1-19.1c-3.9-6.7-12.4-9-19.1-5.1 c-4.9,2.8-7.4,8.1-6.9,13.4L0.7,169.9C1.6,173.7,3.7,177.2,6.6,179.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.1,182.5c-1.3-0.7-2.5-1.6-3.5-2.6L6.5,180c1.1,1,2.2,1.9,3.5,2.6l21.6,12.5l0.1-0.1L10.1,182.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M165.9,140.7c6.7-3.9,9-12.4,5.1-19.1c-3.9-6.7-12.4-9-19.1-5.1c-4.9,2.8-7.4,8.1-6.9,13.4L31.8,195 l11.6,6.7l107.4-61.8C155.1,143,161,143.5,165.9,140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M198,51.1L149.3,23L114.1,2.7c-6.2-3.6-13.8-3.6-20,0L10,51C3.8,54.6,0,61.2,0,68.4v96.9 c0,1.6,0.2,3.2,0.6,4.7l0.1-0.1c-0.4-1.5-0.6-3.1-0.6-4.7V68.4c0-7.2,3.8-13.8,10-17.3l84-48.3c6.2-3.6,13.8-3.5,20,0l35.2,20.3 l48.6,28c6.2,3.6,10,10.2,10,17.3v96.9c0,7.1-3.8,13.7-10,17.3L114.2,231c-6.2,3.6-13.8,3.6-20,0l-14.9-8.6l-0.1,0.1l15,8.7 c6.2,3.6,13.8,3.6,20,0l83.8-48.4c6.2-3.6,10-10.2,10-17.3v-97C208,61.3,204.2,54.7,198,51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.8,128.1c6.7-3.9,15.2-1.6,19.1,5.1c3.9,6.7,1.6,15.2-5.1,19.1c-4.9,2.8-10.8,2.3-15.1-0.7L6.6,179.9 c1.1,1,2.2,1.9,3.5,2.6L31.8,195L145,129.8c-0.5-5.3,2-10.6,6.9-13.4c6.7-3.9,15.2-1.5,19.1,5.1c3.9,6.7,1.5,15.2-5.1,19.1 c-4.9,2.8-10.8,2.3-15.1-0.7L43.4,201.7l24.3,14l55.4-32c-0.5-5.3,2-10.6,6.9-13.4c6.7-3.9,15.2-1.6,19.1,5.1 c3.9,6.7,1.6,15.2-5.1,19.1c-4.9,2.8-10.8,2.3-15.1-0.7l-49.6,28.7l14.9,8.6c6.2,3.6,13.8,3.6,20,0l83.7-48.3 c6.2-3.6,10-10.2,10-17.3V68.5c0-7.1-3.8-13.7-10-17.3l-48.6-28L114.1,2.8c-6.2-3.6-13.8-3.6-20,0l-84,48.3 c-6.2,3.6-10,10.2-10,17.3v96.7c0,1.6,0.2,3.2,0.6,4.7l49.2-28.3C49.4,136.3,51.9,130.9,56.8,128.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Medium_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M276.3,128.3h-18.7v38.5h-15v-100h42.1c19,0,32.1,12.3,32.1,30.7c0,18-12.1,27.6-24.9,29.2l25.6,40h-17.4 L276.3,128.3z M282.8,80h-25.2v35.1h25.2c10.8,0,18.6-7,18.6-17.5C301.4,87,293.6,80,282.8,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.9,73.7c0-4.8,4-8.7,8.7-8.7c4.8,0,8.7,3.9,8.7,8.7s-3.9,8.5-8.7,8.5C336.9,82.2,332.9,78.5,332.9,73.7 z M335,94.4h13.5v72.4H335V94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M375.8,175.5c6,6.9,13.3,9.6,23.2,9.6c11.2,0,22.5-5.4,22.5-20.7V155c-5.5,7.2-14.1,12.4-23.8,12.4 c-18.7,0-32.2-13.8-32.2-37.5c0-23.2,13.5-37.3,32.2-37.3c9.4,0,18,4.5,23.8,12.3V94.4H435V164c0,24.9-18.1,32.2-36,32.2 c-12.1,0-21-2.5-29.7-10.8L375.8,175.5z M421.5,115.2c-3.8-5.8-12-10.6-20.1-10.6c-13.5,0-21.9,10.5-21.9,25.3 c0,15,8.4,25.5,21.9,25.5c8.1,0,16.3-5,20.1-10.8V115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M454.4,73.7c0-4.8,4-8.7,8.7-8.7c4.8,0,8.7,3.9,8.7,8.7s-3.9,8.5-8.7,8.5C458.4,82.2,454.4,78.5,454.4,73.7 z M456.5,94.4H470v72.4h-13.5V94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M491.4,66.8h13.5v100h-13.5V66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M521.9,130.5c0-20.8,14.1-37.9,36.6-37.9c22.6,0,36.6,17.1,36.6,37.9c0,21-13.9,38.1-36.6,38.1 C536,168.6,521.9,151.5,521.9,130.5z M581,130.5c0-13.6-7.9-25.9-22.5-25.9c-14.4,0-22.5,12.3-22.5,25.9 c0,13.8,8.1,26.1,22.5,26.1C573,156.6,581,144.3,581,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M618,175.5c6,6.9,13.3,9.6,23.2,9.6c11.2,0,22.5-5.4,22.5-20.7V155c-5.5,7.2-14.1,12.4-23.8,12.4 c-18.7,0-32.2-13.8-32.2-37.5c0-23.2,13.5-37.3,32.2-37.3c9.4,0,18,4.5,23.8,12.3V94.4h13.5V164c0,24.9-18.1,32.2-36,32.2 c-12.1,0-21-2.5-29.7-10.8L618,175.5z M663.8,115.2c-3.8-5.8-12-10.6-20.1-10.6c-13.5,0-21.9,10.5-21.9,25.3 c0,15,8.4,25.5,21.9,25.5c8.1,0,16.3-5,20.1-10.8V115.2z"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Hilfe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TXT__x2F__Proxima__x2F__Orange"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Small__x2F__Orange__x2F__Fill"
  }), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRigilog);
export default __webpack_public_path__ + "static/media/logo_rigilog.0717381d2f70fe4785de001415ec7f59.svg";
export { ForwardRef as ReactComponent };